import React from 'react'
import {Button,
    createStyles,
    makeStyles,} from "@material-ui/core";
import TopSection from "./topSection"
import BodySection from "./bodySection"
import {CoElevatedPanel} from "../../../components/CoPanel"

const useStyles = makeStyles((theme) =>
  createStyles({
    bottomButton:{
        width: "100%",
        marginBottom: "50px",
        marginTop:"40px",
    }

  })
)


const ReceivableMainCard = (props)=>{
    console.log("card => ",props);
    const {
        data: {
            topSection={},
            bodySection={},
            onClickDownloadStatment= ()=>{}
        }={}
    }=props
    const classes = useStyles()
    console.log({topSection, bodySection, onClickDownloadStatment});
    return (
        // <CoElevatedPanel hasHorizontalMargin={false} hasVerticalMargin={false}>
        // <div style={{padding:"5px"}}>
        <div>
            <div
            style={{
                display: "flex",
                flexDirection: "row",
            }}>
                <TopSection data={topSection}/>
            </div>
            <div>
                {
                    bodySection?.itemList.map((item)=>{
                        return <BodySection key={item?.key}  keyTitle={item?.key} value={item?.value} />
                    })
                }
            </div>
            <div>
                <Button  
                    variant="contained" 
                    color="secondary" 
                    onClick={()=> {onClickDownloadStatment()}} 
                    className={classes.bottomButton}
                    // classes={{
                    //   root: classes.approveContainedRoot,
                    //   disabled: classes.aproveContainedDisabled,
                    //   containedPrimary: classes.approveContainedPrimary,
                    // }}
                    > Download Statement </Button>
            </div>
        </div>
        // </CoElevatedPanel>
    )
}

export default ReceivableMainCard;